import { defineComponent as _defineComponent } from 'vue'
import Breadcrumb from '@/components/ui/breadcrumb/Breadcrumb.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Map.layout',
  props: {
    crumbs: null,
    value: null
  },
  setup(__props: any) {



return { __sfc: true,Breadcrumb }
}

})